export enum BiqQueryPropertyType {
    WEB_EVENT = "WebEvent",
}

export enum FacebookPropertyType {
    FACEBOOK_EVENT = "Facebook",
}

export enum PinterestPropertyType {
    PINTEREST_EVENT = "Pinterest",
}

export enum TikTokPropertyType {
    TIKTOK_EVENT = "TikTok",
}

export enum YotpoPropertyType {
    YOTPO_EVENT = "Yotpo",
}

export enum TrackingiqQueryPEventFields {
    Brand = "brand",
    ReferralPage = "referral_page",
    UserAgent = "userAgent",
    Environment = "environment",
    IPAddressClient = "ip_address_client",
    DeviceType = "deviceType",
    OperatingSystem = "operating_system",
    Cookie = "cookie",
    DocLocation = "doc_location",
    EventName = "event_name",
    EventID = "event_id",
    PagePath = "page_path",
    Widget = "widget",
    CountryCode = "country_code",
    ClickText = "click_text",
    MetaData = "meta_data",
    PublishTimeUTC = "publish_time_utc",
    UserId = "user_id",
    Events = "events",
    UserData = "user_data"
}
